import React, { useEffect, useState } from 'react'
import MaterialTable from '@material-table/core'
import { Colors } from '@auteco/theme'
import { Button, IconButton, Typography } from '@material-ui/core'
import { ArrowRightAltOutlined } from '@material-ui/icons'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import {
  deleteEvent,
  getEvents,
  getEventsMaterial,
  getUsersToConfig,
} from '@auteco/services/snopServices'
import { dateToLocal } from '@auteco/utils/dateToLocal'
import { initialAlert } from '@auteco/constants'
import { Alert } from '@auteco/components/snopComponents/Alert'
import DialogAddEvent from '../DialogAddEvent/DialogAddEvent'
import { useStyles } from './styles'

const EventsTable = ({ groupId, material, getconsolidadoInfo }) => {
  const [users, setUsers] = useState()
  const [openDialog, setOpenDialog] = useState(false)
  const [edit, setEdit] = useState(false)
  const [eventsGroup, setEventsGroup] = useState([])
  const [eventsMaterial, setEventsMaterial] = useState([])
  const [selectedEvent, setSelectedEvent] = useState()
  const [currentMaterial, setCurrentMaterial] = useState('')
  const [alertInfo, setAlertInfo] = useState(initialAlert)

  const classes = useStyles()

  const getUsers = async () => {
    const { usuarios } = await getUsersToConfig()
    if (usuarios) {
      setUsers(usuarios)
    }
  }

  const onCloseDialog = () => {
    setOpenDialog(false)
    setEdit(false)
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const onGetEventsGroup = async () => {
    const { eventos } = await getEvents({ id: groupId })
    if (eventos) {
      setEventsGroup(eventos)
      if (selectedEvent && !selectedEvent?.material) {
        const newSelected = eventos.find(
          (event) => event.id === selectedEvent.id,
        )
        setSelectedEvent(newSelected)
      }
    }
  }

  const onGetEventsMaterial = async () => {
    const body = {
      id: 0,
      material,
    }
    const { eventos } = await getEventsMaterial({ params: body })
    if (eventos) {
      const formated = eventos.map((event) => ({ ...event, material }))
      const events = eventos.length > 0 ? formated : eventos
      setEventsMaterial(events)
      if (selectedEvent && selectedEvent?.material) {
        const newSelected = formated.find(
          (event) => event.id === selectedEvent.id,
        )
        setSelectedEvent(newSelected)
      }
    }
  }

  const onGetEvents = () => {
    onGetEventsGroup()
    onGetEventsMaterial()
  }

  const onAddEventGroup = () => {
    setCurrentMaterial('')
    setOpenDialog(true)
  }

  const onAddEventMaterial = () => {
    setCurrentMaterial(material)
    setOpenDialog(true)
  }

  const onEditEvent = ({ event }) => {
    if (event.material) {
      setCurrentMaterial(material)
    }
    setOpenDialog(true)
    setEdit(true)
    setSelectedEvent(event)
    console.log('event', event)
    console.log(event)
  }

  const onDeleteEvent = async ({ event }) => {
    const { success } = await deleteEvent({ id: event.id, groupId })
    if (success === 1) {
      getconsolidadoInfo()
      onGetEvents()
      setAlertInfo(initialAlert)
    }
  }

  const onDeleteEventAlert = ({ event }) => {
    setSelectedEvent(event)
    setAlertInfo({
      title: '¡Espera!',
      content: 'Estás a punto de eliminar este evento, ¿deseas continuar?',
      textBtn1: 'Cancelar',
      textBtn2: 'Continuar',
      open: true,
      onClose: onCloseAlert,
      funcBtn: () => onDeleteEvent({ event }),
    })
  }

  const findInChargePerson = ({ rowData }) => {
    const formatedUser = users.find(
      (user) => user.id === rowData.responsable_id,
    )
    return `${formatedUser.nombre} ${formatedUser.apellido}`
  }

  const columns = [
    {
      title: 'Masivo',
      field: 'masivo',
     
      render: (rowData) =>
        (rowData.masivo && <p>🟢</p>) ||  <p>-</p>,
    },
    {
      title: 'Evento',
      field: 'descripcion',
    },
    {
      title: 'Inicio',
      field: 'meses',
      render: (rowData) =>
        (rowData.meses && rowData.meses[0].ejecucion) || null,
    },
    {
      title: 'Fin',
      field: 'meses',
      render: (rowData) =>
        rowData.meses && rowData.meses[rowData.meses.length - 1].ejecucion,
    },
    {
      title: 'Creación',
      field: 'fecha_creacion',
      render: (rowData) => dateToLocal(rowData.creacion).formattedDateAndHour,
    },
    {
      title: 'Actualización',
      field: 'actualizacion',
      render: (rowData) =>
        (rowData.actualizacion !== null &&
          dateToLocal(rowData.actualizacion).formattedDateAndHour) ||
        null,
    },
    {
      title: 'Mes y cantidad',
      field: 'meses',
      render: (rowData) =>
        rowData.meses && (
          <div>
            {rowData.meses.map((month) => (
              <div className={classes.months} key={rowData.ejecucion}>
                <Typography>{month.ejecucion}</Typography>
                <ArrowRightAltOutlined />
                <Typography>{month.cantidad}</Typography>
              </div>
            ))}
          </div>
        ),
    },
    {
      title: 'Responsable',
      field: 'responsable',
      render: (rowData) => users && findInChargePerson({ rowData }),
    },
    {
      title: 'Editar',
      field: 'editar',
      headerStyle: {
        maxWidth: '20px',
      },
      cellStyle: {
        maxWidth: '40px',
      },
      render: (rowData) => (
        <IconButton onClick={() => onEditEvent({ event: rowData })}>
          <EditIcon />
        </IconButton>
      ),
    },
    {
      title: 'Eliminar',
      field: 'eliminar',
      headerStyle: {
        maxWidth: '20px',
      },
      render: (rowData) => (
        <IconButton onClick={() => onDeleteEventAlert({ event: rowData })}>
          <DeleteIcon />
        </IconButton>
      ),
    },
  ]

  useEffect(() => {
    getUsers()
    onGetEvents()
    console.log('events table test', groupId)
  }, [])

  const eventos = [...eventsMaterial]
  return (
    <>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      {users && (
        <DialogAddEvent
          users={users}
          groupId={groupId}
          edit={edit}
          item={selectedEvent}
          material={currentMaterial}
          onGetEvents={onGetEvents}
          open={openDialog}
          onClose={() => onCloseDialog()}
          getconsolidadoInfo={getconsolidadoInfo}
        />
      )}
      <Button className={classes.createEventBtn} onClick={onAddEventGroup}>
        Evento por grupo
      </Button>
      <Button className={classes.createEventBtn} onClick={onAddEventMaterial}>
        Evento por material
      </Button>
      <MaterialTable
        title=""
        style={{ marginTop: '20px' }}
        data={eventos}
        columns={columns}
        options={{
          rowStyle: (rowData, index) => ({
            backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
            padding: '5px',
            fontSize: '12px',
          }),
          pageSize: 20,
          pageSizeOptions: [20, 50, 100],
          headerStyle: {
            backgroundColor: Colors.BLUE,
            color: '#f1f1f1',
            fontSize: '14px',
            fontWeight: 700,
          },
        }}
      />
    </>
  )
}

export { EventsTable }
